var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Styled } from './style';
function getTimeDigit(value) {
    return value.toString().padStart(2, '0');
}
export function defaultTimeRenderer(ms) {
    var hours = Math.floor(ms / 3600000);
    ms = ms - hours * 3600000;
    var minutes = Math.floor(ms / 60000);
    ms = ms - minutes * 60000;
    var seconds = Math.floor(ms / 1000);
    return "" + (hours > 0 ? getTimeDigit(hours) + ':' : '') + getTimeDigit(minutes) + ":" + getTimeDigit(seconds);
}
var Timer = /** @class */ (function (_super) {
    __extends(Timer, _super);
    function Timer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            displayTime: _this.props.renderer(0),
            startTimestamp: 0,
            pauseStartTimestamp: null,
            totalPauseDuration: 0,
        };
        _this.setStartingPoint = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setState({
                            startTimestamp: new Date().getTime(),
                            totalPauseDuration: 0,
                            displayTime: this.props.renderer(this.props.startTime),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.start = function () {
            _this.setInterval();
        };
        _this.stop = function () {
            _this.clearInterval();
        };
        _this.pause = function () {
            _this.clearInterval();
            _this.setState({
                pauseStartTimestamp: new Date().getTime(),
            });
        };
        _this.resume = function () {
            _this.setState(function (prevState) {
                var currentPauseDuration = prevState.pauseStartTimestamp !== null
                    ? new Date().getTime() - prevState.pauseStartTimestamp
                    : 0;
                return {
                    totalPauseDuration: prevState.totalPauseDuration + currentPauseDuration,
                    pauseStartTimestamp: null,
                };
            });
            _this.setInterval();
        };
        _this.setInterval = function () {
            _this.clearInterval();
            _this.interval = window.setInterval(_this.updateTime, _this.props.updateInterval);
        };
        _this.clearInterval = function () {
            window.clearInterval(_this.interval);
        };
        _this.updateTime = function () {
            _this.setState(function (prevState) { return ({
                displayTime: _this.props.renderer(new Date().getTime() - prevState.startTimestamp - prevState.totalPauseDuration + (_this.props.startTime ? _this.props.startTime : 0)),
            }); });
        };
        return _this;
    }
    Timer.prototype.componentDidMount = function () {
        this.setStartingPoint();
        if (!this.props.pause) {
            this.start();
        }
    };
    Timer.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return this.state.displayTime !== nextState.displayTime;
    };
    Timer.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.props.startTime !== prevProps.startTime || this.props.reference !== prevProps.reference)) return [3 /*break*/, 2];
                        this.stop();
                        return [4 /*yield*/, this.setStartingPoint()];
                    case 1:
                        _a.sent();
                        this.start();
                        _a.label = 2;
                    case 2:
                        if (!(this.props.pause !== prevProps.pause)) return [3 /*break*/, 6];
                        if (!this.props.pause) return [3 /*break*/, 3];
                        this.pause();
                        return [3 /*break*/, 6];
                    case 3:
                        if (!!this.state.startTimestamp) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.setStartingPoint()];
                    case 4:
                        _a.sent();
                        this.start();
                        return [3 /*break*/, 6];
                    case 5:
                        this.resume();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Timer.prototype.componentWillUnmount = function () {
        this.clearInterval();
    };
    Timer.prototype.render = function () {
        return React.createElement(Styled, { className: "timer" }, this.state.displayTime);
    };
    Timer.defaultProps = {
        startTime: 0,
        updateInterval: 200,
        renderer: defaultTimeRenderer,
    };
    return Timer;
}(React.Component));
export default Timer;
//# sourceMappingURL=index.js.map